/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GlobalRulesListQueryVariables = {|
  greenMachineSessionID: string
|};
export type GlobalRulesListQueryResponse = {|
  +buildRulesForGreenMachineSession: ?{|
    +selectedBuildRules: ?$ReadOnlyArray<?{|
      +id: string,
      +name: string,
    |}>,
    +unselectedBuildRules: ?$ReadOnlyArray<?{|
      +id: string,
      +name: string,
    |}>,
  |}
|};
export type GlobalRulesListQuery = {|
  variables: GlobalRulesListQueryVariables,
  response: GlobalRulesListQueryResponse,
|};
*/


/*
query GlobalRulesListQuery(
  $greenMachineSessionID: ID!
) {
  buildRulesForGreenMachineSession(greenMachineSessionId: $greenMachineSessionID) {
    selectedBuildRules {
      id
      name
    }
    unselectedBuildRules {
      id
      name
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "greenMachineSessionID"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "greenMachineSessionId",
        "variableName": "greenMachineSessionID"
      }
    ],
    "concreteType": "BuildRulesForGreenMachineSessionType",
    "kind": "LinkedField",
    "name": "buildRulesForGreenMachineSession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BuildRuleType",
        "kind": "LinkedField",
        "name": "selectedBuildRules",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BuildRuleType",
        "kind": "LinkedField",
        "name": "unselectedBuildRules",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GlobalRulesListQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GlobalRulesListQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "137f4923e9785de154f8d1161c167401",
    "id": null,
    "metadata": {},
    "name": "GlobalRulesListQuery",
    "operationKind": "query",
    "text": "query GlobalRulesListQuery(\n  $greenMachineSessionID: ID!\n) {\n  buildRulesForGreenMachineSession(greenMachineSessionId: $greenMachineSessionID) {\n    selectedBuildRules {\n      id\n      name\n    }\n    unselectedBuildRules {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '11355850439e0a4b20e6df8ef256cf67';

module.exports = node;
